import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ContractRefundPayment.Export.IRequest;
type Response = Api.Finance.ContractRefundPayment.Export.IResponse;
type Headers = Api.Finance.ContractRefundPayment.Export.IHeaders;
const url = '/api/Finance/ContractRefundPayment/ExportToExcel';
export default async function contractRefundPaymentExportApi(query: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, null, query),
    headers: getDefaultHeaders(),
  });
}
